<template>
  <v-menu offset-y bottom nudge-bottom="5">
    <template #activator="{ on, attrs }">
      <v-tooltip top>
        <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <v-btn
            class="pa-0 ml-2"
            depressed
            rounded
            small
            style="height: 30px; min-width: 30px"
            v-bind="{ ...attrs, ...tooltipAttrs }"
            v-on="{ ...on, ...tooltipOn }"
          >
            <v-icon small>{{ selectedItem.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('agenda_items_sidebar_navigation_tooltip') }}</span>
      </v-tooltip>
    </template>
    <v-list class="py-0">
      <v-list-item v-for="item in items" :key="item.key" :disabled="value === item.key" @click="selectedKey = item.key">
        <v-list-item-content>
          <v-list-item-title class="d-flex">
            <v-icon class="pr-1" small>{{ item.icon }}</v-icon> {{ $t(item.label) }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
const NAVIGATION_STORAGE_KEY = 'agenda_item_sidebar_navigation_slot'

export default {
  name: 'AgendaItemsNavigationSwitcher',
  props: {
    value: {
      type: String,
      default: null,
    },
    meeting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedKey: null,
    }
  },
  computed: {
    defaultItem() {
      return this.meeting.has_tagesordnung ? 'tagesordnung_list' : 'agenda_item_list'
    },
    items() {
      return [
        {
          label: this.$t('agenda_items_sidebar_navigation_agenda_item'),
          key: 'agenda_item_list',
          icon: 'mdi-view-sequential',
        },
        {
          label: this.$t('agenda_items_sidebar_navigation_tagesordnung'),
          key: 'tagesordnung_list',
          icon: 'mdi-calendar-text',
        },
      ]
    },
    selectedItem() {
      return this.items.find((item) => item.key === this.selectedKey)
    },
  },
  watch: {
    selectedKey(value) {
      localStorage.setItem(NAVIGATION_STORAGE_KEY, value)
      this.$emit('input', value)
    },
  },
  created() {
    this.selectedKey = localStorage.getItem(NAVIGATION_STORAGE_KEY) ?? this.defaultItem
  },
}
</script>
